import {DragDropModule} from '@angular/cdk/drag-drop';
import {LayoutModule} from '@angular/cdk/layout';
import {OverlayModule} from '@angular/cdk/overlay';
import {PortalModule} from '@angular/cdk/portal';
import {CommonModule} from '@angular/common';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatTooltipModule} from '@angular/material/tooltip';
import {TranslateModule} from '@ngx-translate/core';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {NgxSpinnerModule} from 'ngx-spinner';


import {FormModule} from '@sim/form';

import {DraggableListComponent} from './draggable-list/draggable-list.component';
import {ListItemDirective} from './draggable-list/list-item.directive';
import {ListDirective} from './draggable-list/list.directive';
import {FilterDialogComponent} from './filter-dialog/filter-dialog.component';
import {FiltersComponent} from './filters/filters.component';
import {InputRepeatableComponent} from './input-repeatable/input-repeatable.component';
import {NoItemsComponent} from './no-items/no-items.component';
import {PageContainerComponent} from './page-container/page-container.component';
import {TableComponent} from './table/table.component';
import {TemplateCellIdDirective} from './table/template-cell.directive';


export * from './draggable-list/draggable-list.component';
export * from './filter-dialog/filter-dialog.component';
export * from './filters/base-filters.component';
export * from './filters/base-table-filtered.component';
export * from './filters/filters.component';
export * from './filters/filters';
export * from './input-repeatable/input-repeatable.component';
export * from './page-container/page-container.component';
export * from './table/base-table.component';
export * from './table/table.component';
export * from './table/table';

const components = [
  DraggableListComponent,
  FiltersComponent,
  InputRepeatableComponent,
  PageContainerComponent,
  TableComponent,
  NoItemsComponent,
];

const dialogs = [
  FilterDialogComponent,
];

const directives = [
  TemplateCellIdDirective,
  ListItemDirective,
  ListDirective,
];

@NgModule({
  declarations: [
    ...components,
    ...directives,
    ...dialogs
  ],
  exports: [
    ...components,
    ...directives,
    ...dialogs,
  ],
  imports: [
    CommonModule,
    DragDropModule,
    FormModule,
    LayoutModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatPaginatorModule,
    MatTooltipModule,
    NgxDatatableModule,
    NgxSpinnerModule,
    OverlayModule,
    PortalModule,
    TranslateModule,
    MatMenuModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UiModule {
}
